import { useState } from "react";
import {
  StyledButtonRow,
  StyledPopupButton,
} from "../../../styles/components/Popup.styled";
import { ModalForm, ModalHeading, ModalInput } from "../Lists.styled";
import { ModalShell } from "./ModalShell";

// Naming a list. Used for both create and rename so the two read the same.
export function ListNameModal(props: {
  heading: string;
  submitLabel: string;
  initialName?: string;
  onSubmit: (name: string) => void;
  onClose: () => void;
}) {
  const [name, setName] = useState(props.initialName ?? "");

  function submit(event: React.FormEvent) {
    event.preventDefault();
    if (name.trim() === "") {
      return;
    }
    props.onSubmit(name);
    props.onClose();
  }

  return (
    <ModalShell onClose={props.onClose}>
      <ModalForm onSubmit={submit}>
        <ModalHeading>{props.heading}</ModalHeading>
        <ModalInput
          autoFocus
          placeholder="List name"
          value={name}
          onChange={(event) => setName(event.target.value)}
        />
        <StyledButtonRow>
          <StyledPopupButton type="button" onClick={props.onClose}>
            Cancel
          </StyledPopupButton>
          <StyledPopupButton type="submit" disabled={name.trim() === ""}>
            {props.submitLabel}
          </StyledPopupButton>
        </StyledButtonRow>
      </ModalForm>
    </ModalShell>
  );
}
